import React from "react";
import styled from "styled-components";
import { Button, Icon } from "@blueprintjs/core";
import { Menu } from "@mantine/core";

const MoreButton = styled(Button)`
  color: var(--global-dark-gray);
  width: 36px;
`;

export const MoreButtonPopover: React.FC<{ content: JSX.Element }> = ({
  content,
}) => {
  return (
    <Menu withinPortal position="bottom">
      <Menu.Target>
        <div>
          <MoreButton intent="success" outlined>
            <Icon icon={"more"} style={{ paddingBottom: "4px" }} />
          </MoreButton>
        </div>
      </Menu.Target>
      <Menu.Dropdown>{content}</Menu.Dropdown>
    </Menu>
  );
};
